export default __webpack_public_path__ + "static/media/copyright.8c7a2b78.svg";